(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mh-foodservice-shop"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mh-foodservice-shop')) {
  customElements.define('mh-foodservice-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cards = Array.from(this.querySelectorAll('[data-bulk-card]'));
      this.grid = this.querySelector('[data-product-grid]');
      this.category = this.querySelector('[data-category-filter]');
      this.size = this.querySelector('[data-size-filter]');
      this.search = this.querySelector('[data-search-filter]');
      this.stock = this.querySelector('[data-stock-filter]');
      this.sort = this.querySelector('[data-sort-filter]');
      this.limit = 12;
      const sizes = new Map();
      this.cards.forEach((card, index) => {
        card.dataset.order = index;
        const select = card.querySelector('[data-pack-select]');
        const initialValue = select.value;
        Array.from(select.options).sort((a,b) => Number(a.dataset.grams) - Number(b.dataset.grams)).forEach(option => {
          select.append(option);
          sizes.set(Number(option.dataset.grams), option.dataset.label);
        });
        select.value = initialValue;
        select.addEventListener('change', () => {
          this.updatePack(card);
          if (this.size.value !== 'all' && Number(select.selectedOptions[0].dataset.grams) !== Number(this.size.value)) this.size.value = 'all';
          this.applyFilters();
        });
        this.updatePack(card);
      });
      Array.from(sizes).sort((a,b) => a[0]-b[0]).forEach(([grams,label]) => {
        const option = document.createElement('option');
        option.value = grams;
        option.textContent = label;
        this.size.append(option);
      });
      this.querySelectorAll('[data-category-count]').forEach(el => {
        el.textContent = this.cards.filter(card => card.dataset.category === el.dataset.categoryCount).length;
      });
      this.querySelectorAll('[data-category-link]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        this.reset();
        this.category.value = link.dataset.categoryLink;
        this.applyFilters();
        this.scrollToProducts();
      }));
      [this.category,this.size,this.stock,this.sort].forEach(control => control.addEventListener('change', () => {
        this.limit = 12;
        this.applyFilters();
      }));
      this.search.addEventListener('input', () => {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => { this.limit = 12; this.applyFilters(); }, 180);
      });
      this.querySelectorAll('[data-reset-filters]').forEach(button => button.addEventListener('click', () => {
        this.reset(); this.applyFilters();
      }));
      this.querySelector('[data-load-more]').addEventListener('click', () => {
        const firstNew = this.limit;
        this.limit += 12;
        this.applyFilters(false);
        this.matches[firstNew]?.querySelector('h3 a')?.focus({preventScroll:true});
      });
      this.addEventListener('add-to-cart', () => {
        this.querySelector('[data-added-status]').textContent = this.dataset.added;
        const drawer = document.querySelector('[data-js-site-cart-sidebar]');
        if (drawer && typeof drawer.show === 'function') drawer.show();
      }, true);
      this.onPopState = () => { this.readFilters(); this.applyFilters(false); };
      window.addEventListener('popstate', this.onPopState);
      this.readFilters();
      this.querySelector('[data-filters]').hidden = false;
      this.applyFilters(false);
    }
    disconnectedCallback() {
      clearTimeout(this.searchTimer);
      window.removeEventListener('popstate', this.onPopState);
    }
    updatePack(card) {
      const option = card.querySelector('[data-pack-select]').selectedOptions[0];
      if (!option) return;
      card.querySelector('[data-pack-id]').value = option.value;
      card.querySelector('[data-pack-price]').textContent = option.dataset.money;
      card.querySelector('[data-pack-unit]').textContent = option.dataset.unit;
      card.querySelector('[data-pack-badge]').textContent = option.dataset.label;
      card.querySelector('[data-pack-add]').textContent = option.dataset.available === 'true' ? this.dataset.addTemplate.replace('[size]', option.dataset.label) : this.dataset.soldOut;
      card.querySelector('[type=submit]').disabled = option.dataset.available !== 'true';
      card.querySelectorAll('[data-product-link]').forEach(link => {
        link.href = option.dataset.url;
        if (link.classList.contains('mh-bulk-card__image')) link.setAttribute('aria-label', card.querySelector('h3').textContent.trim() + ' — ' + option.dataset.label);
      });
      const image = card.querySelector('.mh-bulk-card__image img');
      if (image && option.dataset.image && image.getAttribute('src') !== option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
      }
      card.dataset.price = option.dataset.price;
    }
    reset() {
      this.category.value='all'; this.size.value='all'; this.search.value=''; this.stock.checked=false; this.sort.value='featured'; this.limit=12;
    }
    readFilters() {
      this.reset();
      const params = new URLSearchParams(window.location.search);
      [['fs_category',this.category],['fs_size',this.size],['fs_sort',this.sort]].forEach(([key,control]) => {
        const value=params.get(key);
        if (value && Array.from(control.options).some(option => option.value===value)) control.value=value;
      });
      this.search.value=params.get('fs_q') || '';
      this.stock.checked=params.get('fs_stock')==='1';
    }
    applyFilters(writeUrl=true) {
      const words=this.search.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
      this.matches=this.cards.filter(card => {
        const select=card.querySelector('[data-pack-select]');
        const eligible=Array.from(select.options).filter(option => (this.size.value==='all' || Number(option.dataset.grams)===Number(this.size.value)) && (!this.stock.checked || option.dataset.available==='true'));
        if (!eligible.length) return false;
        if (!eligible.includes(select.selectedOptions[0])) {
          select.value=(eligible.find(option => option.dataset.available==='true') || eligible[0]).value;
          this.updatePack(card);
        }
        return (this.category.value==='all' || card.dataset.category===this.category.value) && words.every(word => card.dataset.search.includes(word));
      });
      this.matches.sort((a,b) => this.sort.value==='price-up' ? Number(a.dataset.price)-Number(b.dataset.price) : this.sort.value==='price-down' ? Number(b.dataset.price)-Number(a.dataset.price) : Number(a.dataset.order)-Number(b.dataset.order));
      this.cards.forEach(card => { card.hidden=true; });
      const ordered=this.cards.slice().sort((a,b) => this.sort.value==='price-up' ? Number(a.dataset.price)-Number(b.dataset.price) : this.sort.value==='price-down' ? Number(b.dataset.price)-Number(a.dataset.price) : Number(a.dataset.order)-Number(b.dataset.order));
      ordered.forEach((card,index) => { if(this.grid.children[index]!==card) this.grid.insertBefore(card,this.grid.children[index] || null); });
      this.matches.forEach((card,index) => { card.hidden=index>=this.limit; });
      const shown=Math.min(this.limit,this.matches.length);
      this.querySelector('[data-result-count]').textContent=this.dataset.countTemplate.replace('[shown]',shown).replace('[total]',this.matches.length);
      this.querySelector('[data-empty]').hidden=this.matches.length>0;
      this.querySelector('[data-load-more]').hidden=shown>=this.matches.length;
      this.querySelectorAll('[data-category-link]').forEach(link => {
        if (link.dataset.categoryLink===this.category.value) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current');
      });
      if (writeUrl) {
        const url=new URL(window.location.href);
        [['fs_category',this.category.value,'all'],['fs_size',this.size.value,'all'],['fs_q',this.search.value.trim(),''],['fs_stock',this.stock.checked?'1':'',''],['fs_sort',this.sort.value,'featured']].forEach(([key,value,empty]) => { if(value!==empty) url.searchParams.set(key,value); else url.searchParams.delete(key); });
        window.history.replaceState(null,'',url);
      }
    }
    scrollToProducts() {
      const heading=this.querySelector('.mh-fs-products h2') || this.querySelector('h1');
      this.querySelector('.mh-fs-products').scrollIntoView({behavior:'instant',block:'start'});
      heading.focus({preventScroll:true});
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
